import React from 'react';
import colours from 'theme/atoms/colours';

interface HelpCircleFilledProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const innerStroke: React.CSSProperties = {
  stroke: colours.neutral[200],
};

const HelpCircleFilled = ({
  size = 24,
  color = 'currentColor',
  ...props
}: HelpCircleFilledProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <circle cx="12" cy="12" r="10" fill={color} />
    <path
      d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={innerStroke}
    />
    <path
      d="M12 17h.01"
      strokeWidth="2"
      strokeLinecap="round"
      style={innerStroke}
    />
  </svg>
);

export default HelpCircleFilled;
